import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const InternationalTaxationTransferPricing = () => {
  const serviceData = {
    title: "International Taxation & Transfer Pricing",
    heading: "International Taxation & Transfer Pricing",
    image: subTopicImages["International Taxation & Transfer Pricing"],
    intro:
      "Strategic advisory for managing cross-border tax exposure and transfer pricing risk",
    description: [
      "When a business operates across borders, taxation becomes significantly more complex. International tax rules involve double taxation treaties, Permanent Establishment (PE) exposure, cross-border withholding tax, transfer pricing documentation, and BEPS & OECD guidelines.",
      "Incorrect interpretation or weak documentation can result in penalties, double taxation, regulatory scrutiny and litigation risk.",
      "At V DOOGAR AND ASSOCIATES, we support multinational companies, foreign subsidiaries, global groups and cross-border investors in structuring and managing international tax exposure in a compliant, efficient and well-documented manner.",
      "We act as a trusted advisor to Boards, CFOs, global tax teams and promoters — ensuring global operations are aligned with both Indian law and international tax standards.",
    ],
    services: [
      {
        title: "Cross-Border Tax & Treaty Advisory",
        text: "We provide clarity on international tax exposure through:",
        list: [
          "advisory on global tax treaties & withholding tax",
          "review of residency, treaty claims & compliance",
          "guidance on dividend, royalty & service fee taxation",
          "planning to avoid double taxation",
        ],
        extraInfo:
          "Helping businesses optimise treaty benefits while remaining fully compliant.",
      },
      {
        title: "Permanent Establishment (PE) Risk Review",
        text: "We assess whether global operations create tax liability in India through:",
        list: [
          "review of contracts, people functions & activities",
          "assessment of PE exposure & business risks",
          "risk mitigation guidance",
          "documentation to support your tax position",
        ],
        extraInfo: "Reducing unintended PE exposure and associated tax risks.",
      },
      {
        title: "Transfer Pricing Advisory & Documentation",
        text: "We ensure inter-company transactions meet Indian TP regulations by supporting:",
        list: [
          "transfer pricing policy & benchmarking",
          "local file documentation & Form 3CEB",
          "review of inter-company agreements",
          "audit & litigation support",
        ],
        extraInfo: "Strengthening defensibility of transfer pricing positions.",
      },
      {
        title: "Litigation & Defence Support",
        text: "We provide end-to-end support during audits and disputes, including:",
        list: [
          "representation before tax authorities",
          "drafting replies & documentation",
          "assessment and appellate support",
          "technical guidance & dispute strategy",
        ],
        extraInfo:
          "Ensuring strong defence through technical expertise and procedural discipline.",
      },
      {
        title: "Advisory to Parent & Subsidiary Entities",
        text: "We advise on structuring compliant, tax-efficient cross-border arrangements, including:",
        list: [
          "royalty & service fee structures",
          "cross-border funding & guarantees",
          "cost-sharing arrangements",
          "repatriation planning",
        ],
        extraInfo:
          "Aligning global group tax structures with Indian regulatory requirements.",
      },
    ],
    benefitsIntro: "How this service adds value to cross-border operations:",
    benefits: [
      "Optimised international tax positions",
      "Reduced risk of double taxation and penalties",
      "Robust transfer pricing documentation",
      "Clear visibility on PE exposure",
      "Strong defence during audits and disputes",
    ],
    research:
      "Our international tax practice blends global tax principles with deep Indian regulatory expertise — helping businesses operate confidently across borders.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default InternationalTaxationTransferPricing;
